<template>
  <v-container style="max-width: 1000px;">
      <v-card 
        class="my-4 pa-4"
        v-for="category in categories"
        :key="'DocType-' + category"
      >
        <p class="text-h6">{{ category.replace("_", ' ') }}</p>
        <v-divider></v-divider>
        <v-simple-table
          class="table--striped"
          dense
        >
          <template v-slot:default>
            <tbody>
              <tr v-for="(item, index) in items.filter(x => x.category == category)" :key="category + '-' + index">
                <td width="90%">{{ item.name }}</td>
                <td width="10%">
                  <v-btn
                    type="button"
                    color="primary"
                    text
                    link
                    small
                    @click="showPdf(item.src)"
                  >
                    Download <v-icon small>mdi-download</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    <PdfViewer :src="targetPdfPath" />
  </v-container>
</template>

<script>
import { common } from "@/mixins";
import PdfViewer from "@/components/PdfViewer";

export default {
  name: "Resources",
  components: {
    PdfViewer,
  },
  async mounted() {
    const response = await this.$store
      .dispatch("inforesource/getAllVM")
      .then((resp) => resp)
      .catch((err) => err);

    this.items = response.data;
    this.categories = [...new Set(this.items.map(x => x.category))].reverse();
  },
  data() {
    return {
      items: null,
      categories: null,
      targetPdfPath: null,
    };
  },
  methods: {
    showPdf(path){
      this.targetPdfPath = path;
      this.$modal.show("pdf-viewer");
    }
  },
  mixins: [ common ],
};
</script>
